import { render, staticRenderFns } from "./PatrolStrategyTag.vue?vue&type=template&id=390bcfbf"
import script from "./PatrolStrategyTag.vue?vue&type=script&lang=js"
export * from "./PatrolStrategyTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports